// Wipes the persisted slices (auth, NMFC cache) on sign-out. They live in
// localStorage, so clearing it is the whole job.
export function clearSlices() {
  localStorage.clear();
}
